import TitleTextView from './TitleText.view';
export default TitleTextView;
